import type { IGeneralLegendOption } from '../types';

const getNodeNumPropertyValue = (node: HTMLElement | null, propertyName: string): number => {
  if (!node) return 0;
  const propertyValueStr = getComputedStyle(node, null).getPropertyValue(propertyName);
  const propertyValueNum = Number.parseFloat(propertyValueStr);
  return Number.isNaN(propertyValueNum) ? 0 : propertyValueNum;
};

export const getNodeWidth = (node: HTMLElement | null): number => getNodeNumPropertyValue(node, 'width');

export const getNodeHorizontalMargin = (node: HTMLElement | null): number => {
  const marginLeft = getNodeNumPropertyValue(node, 'margin-left');
  const marginRight = getNodeNumPropertyValue(node, 'margin-right');
  return marginLeft + marginRight;
};

export const analysisLegendOption = (option: string | IGeneralLegendOption): IGeneralLegendOption => {
  const isSimpleOption = typeof option === 'string';
  if (isSimpleOption)
    return {
      icon: '',
      name: option,
    };

  return {
    icon: option?.icon ?? '',
    name: option?.name ?? '',
  };
};
